import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { getDataAttr } from './utils';
const TabPane = function TabPane(props) {
    const { className, destroyInactiveTabPane, active, forceRender, rootPrefixCls, style, children, placeholder, ...restProps } = props;
    const [rendered, setRendered] = useState(active);
    const prefixCls = `${rootPrefixCls}-tabpane`;
    const cls = classnames(prefixCls, active ? `${prefixCls}-active` : `${prefixCls}-inactive`, className);
    useEffect(() => {
        if (!destroyInactiveTabPane && active) {
            setRendered(true);
        }
    }, [destroyInactiveTabPane, active]);
    return (React.createElement("div", Object.assign({ style: style, role: "tabpanel", "aria-hidden": active ? 'false' : 'true', className: cls }, getDataAttr(restProps)), forceRender || (destroyInactiveTabPane ? active : rendered) ? children : placeholder));
};
TabPane.displayName = 'TabPane';
TabPane.defaultProps = {
    overflowCount: 99,
    showCount: true,
};
export default TabPane;
